import Service from '../Service'
import {http} from '../config'

export default class FrequenciaService extends Service{

    constructor(){
        super('frequencia');
    }

    GetFiltro(parametros, filter){
        
        if (filter) {
            let paramTemp = '';

            if(filter.projetoId != "0"){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `projetoId eq ${filter.projetoId}`;
            }

            if(filter.beneficiarioId != "0"){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `beneficiarioId eq ${filter.beneficiarioId}`;
            }

            if(filter.dataInicio){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `data ge ${filter.dataInicio}`;
            }

            if(filter.dataTermino){
                if (paramTemp) { paramTemp += ' and '; }
                paramTemp += `data le ${filter.dataTermino}`;
            }
    
            if (paramTemp) {
    
                if(parametros){
                    parametros += '&';
                }
                else {
                    parametros += '?';
                }

                parametros += `$filter=${paramTemp}`;
            }    
        }
    
        return parametros;
    }

    ListarComFiltro(page, pageSize, sortby, desc, search, columns, filter){
        
        let parametros = this.GetParamentroPaginacaoOrdenacao(page, pageSize, sortby, desc, search, columns);
        
        parametros = this.GetFiltro(parametros, filter);

        return http.get(`${this._nomeControle}${parametros}`);
    }

    Obter(projetoId, data){
        return http.get(`${this.getNomeControle()}/obter`, {
            params: {
                projetoId,
                data
            }
        });
    }

    async SalvarLista(lista){
        return http.post(`${this.getNomeControle()}/lista`, lista);
    }

    RelatorioSimples(projetoId, dataInicio, dataFim, beneficiarioIdInicio, beneficiarioIdFim, ordena){
        return http.get(`${this.getNomeControle()}/RelatorioSimples`, {
            params: {
                projetoIdInicio: projetoId,
                projetoIdFim: projetoId,
                dataInicial: dataInicio,
                dataFinal: dataFim,
                beneficiarioIdInicio: beneficiarioIdInicio,
                beneficiarioIdFim: beneficiarioIdFim,
                ordena: ordena
            }
        });
    }

    RelatorioGerencial(projetoId, dataInicio, dataFim){
        return http.get(`${this.getNomeControle()}/RelatorioGerencial`, {
            params: {
                projetoId: projetoId,
                dataInicial: dataInicio,
                dataFinal: dataFim,
            }
        });
    }
  
  }